// 问卷调查
<template>
    <div class="box">
        <div class="text1">旺信通调查问卷</div>
        <div>
            <img class="img" :src="require('@/assets/WelfareFebruary3.png')" >
        </div>
        <div>
            <div class="text2">您的建议是我们更新的方向</div>
            <div class="text2">您的意见是我们服务的动力</div>
        </div>
        <div @click="show_popup(1)" class="text3">
            <img :src="require('@/assets/bianji.png')" >
            <span>我要提建议</span>
        </div>
        <div>
            <div class="text4">感谢您的加入</div>
            <div class="text4">赠送您超级礼包权益</div>
        </div>
        <div class="text5">3个月旺信通+不限量微信提醒+1200条短信+300分钟通话</div>
        <div @click="show_popup(2)" class="button">仅需51元获取</div>
        <div class="text6">原价150元/3个月</div>

        <Popup v-model="popup_show"
        position="top"
        overlay-class="popup_box"
        :close-on-click-overlay="false"
        :lock-scroll="true"
        :lazy-render="false">
            <img class="WXTExtension_popup" :style="click_button==1?'height:55vw':'height:51vw'" :src="click_button==1?popup_img1:popup_img2">
        </Popup>
    </div>
</template>
<script>
import { Popup } from 'vant';
export default {
    components:{
        Popup,
    },
    data(){
        let popup_img1
        if(this.$config.SystemOS=='IOS'){
            popup_img1 = this.$OSSBaseUrl +'Questionnaire_popup_ios.png';
        }else{
            popup_img1 = this.$OSSBaseUrl + 'Questionnaire_popup_android.png';
        }
        let popup_img2
        if(this.$config.SystemOS=='IOS'){
            popup_img2 = this.$OSSBaseUrl +'renew_tips_ios.png';
        }else{
            popup_img2 = this.$OSSBaseUrl + 'renew_tips_android.png';
        }
        return{
            popup_img1,
            popup_img2,
            click_button:1,
            popup_show:false,
            record_data:{
                page_from:'main_page',
                page_name:'WelfareFebruary/Questionnaire',
                page_time:'0.00',
                receiver_id: '',
                page_param:{dayhour:this.$route.query.dayhour,},
            },
        }
    },
    mounted(){
        this.$store.dispatch('Public/inH5Record', this.record_data)
    },
    methods:{
        show_popup(num){
            let URL = window.location.href
            if( URL.includes('&jump_link=') ){
                let first_index = URL.indexOf('&jump_link=')
                URL = URL.substr(0,first_index)
            }
            switch (num) {
                case 1:
                    history.replaceState({},0,URL+'&jump_link=1')
                    break;
                case 2:
                    history.replaceState({},0,URL+'&jump_link=2')
                    break;
            }
            let data = JSON.parse(JSON.stringify(this.record_data))
            data.btn_name = `WelfareFebruary/Questionnaire/${num==1?'Q_btn':'Buy_btn'}`
            this.$store.dispatch('Public/inH5Record', data)
            this.popup_show = true
            this.click_button = num
        }
    },
}
</script>
<style lang="scss" scoped>
    @import './Questionnaire.scss';
</style>